import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import CustomTable from "rc-material-table";
import PageHeader from "../../component/header";
import { useApi } from "../../hooks";
import { getToast } from "../../common/utils";
import { apiMenuArticle, method } from "../../apiPath";
import keyNames from "../../keyName";
import { columns } from "./columns";

const { get } = method;

const MenuArticle = () => {
  const hitApi = useApi();
  const navigate = useNavigate();
  const storeData = useSelector((state) => state.mainReducer);
  const { menuArticleData } = storeData;
  const [entries, setEntries] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const callBack = (cbd) => {
    navigate("/app/add-menu-article", { state: cbd });
  };

  const btn = {
    show: true,
    text: "Add Menu Article",
    type: "contained",
    callBack: () => callBack("add"),
  };

  useEffect(() => {
    if (!menuArticleData) {
      hitApi(apiMenuArticle, null, get, keyNames.menuArticleData);
    } else if (Array.isArray(menuArticleData)) {
      setEntries(
        menuArticleData.map((item, index) => ({
          ...item,
          sortOrder: index + 1,
        }))
      );
    }
  }, [menuArticleData, hitApi]);

  const handleView = (item, path) => {
    navigate(path, { state: item });
  };

  const handleDelete = (id) => {
    const toast = getToast("success");
    hitApi(
      `${apiMenuArticle}/${id}`,
      null,
      method.delete,
      keyNames.menuArticleData,
      toast,
      {
        type: "delete",
      }
    );
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const filteredEntries = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) return entries;
    return entries.filter((item) =>
      item.heading1?.toLowerCase().includes(term)
    );
  }, [entries, searchTerm]);

  const handleSearchChange = (value) => {
    setSearchTerm(value);
    setPage(0);
  };

  const pagination = {
    rowsPerPageOptions: [8, 10, 20],
    rowsPerPage,
    page,
    count: filteredEntries.length,
    component: "div",
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage,
  };
  const paginatedData = useMemo(() => {
    const startIndex = page * rowsPerPage;
    return filteredEntries.slice(startIndex, startIndex + rowsPerPage);
  }, [filteredEntries, page, rowsPerPage]);

  return (
    <>
      <PageHeader
        btn={btn}
        title="All Menu Articles"
        search={{
          value: searchTerm,
          onChange: handleSearchChange,
          placeholder: "Search by Heading 1",
        }}
      />

      {entries.length === 0 ? (
        <Box
          sx={{
            mt: 5,
            textAlign: "center",
            p: 4,
            border: "1px dashed grey",
            borderRadius: 2,
            backgroundColor: "#fafafa",
          }}
        >
          <Typography variant="h6" color="text.secondary">
            No Menu Article found for this user.
          </Typography>
        </Box>
      ) : filteredEntries.length === 0 ? (
        <Box
          sx={{
            mt: 5,
            textAlign: "center",
            p: 4,
            border: "1px dashed grey",
            borderRadius: 2,
            backgroundColor: "#fafafa",
          }}
        >
          <Typography variant="h6" color="text.secondary">
            No Menu Article found for &quot;{searchTerm}&quot;.
          </Typography>
        </Box>
      ) : (
        <CustomTable
          columns={columns(handleView, handleDelete)}
          data={paginatedData ?? []}
          pagination={pagination}
          tableProps={{
            stickyHeader: true,
          }}
          sx={{
            mt: 3,
            "&>.MuiPaper-elevation": {
              boxShadow: "none",
              overflowX: "auto",
              maxHeight: "calc(100vh - 260px)",
            },
          }}
        />
      )}
    </>
  );
};

export default MenuArticle;
